<template>
<section class="main">
          <div class="content_page_title">
              <h1>Liste des stations 4G/5G</h1>
          </div>
          <div class="main_content">
            <fiche-station ref="ficheStation"></fiche-station>
              <div class="list">

                  <h2>Stations 4G/5G</h2>
                  <table>
                      <thead>
                          <tr>
                              <th>Numéro de la station</th>
                              <th>
                                  Distance
                                  <span class="icon_info little grey" title="La distance est..."></span>
                              </th>
                              <th>
                                  Technologie
                              </th>
                              <th>
                                  Mise en service
                                  <span class="icon_info little info_grey" title="La mise en service représente le moment..."></span>
                              </th>
                              <th>Détails</th>
                          </tr>
                      </thead>
                      <tbody>
                          <tr v-for= "(station, index) in stations" :key="index">
                              <td>{{station.properties.numeroStation}}</td>
                              <td>{{station.properties.distance}} km</td>
                              <td>{{station.properties.technoLte}}</td>
                              <td>{{printDate(station.properties.dateDebut)}}
                                <!--<span class= "pin pin_station_4G" :style="{backgroundColor: findClass(station.properties.dateDebut)}"  :title="`${findTitle(station.properties.dateDebut)}`" ></span>-->
                              <td>
                                  <button class="icon_info big info_blue" title="Voir le détail" @click="openLte(station)"></button>
                              </td>
                          </tr>
                      </tbody>
                  </table>

              </div>
          </div>
      </section>
    </template>
    <script>
    /* eslint-disable */
    import axios from 'axios'
    import FicheStation from '../cartographie/FicheLte.vue'
    import * as eventTypes from '../../bus/event-types.js'
    import EventBus from '../../bus'
    import storeJs from 'store'
    import moment from 'moment'

    export default {
      name: 'Station',
      components: {
        FicheStation
      },
      data() {
        return {
          stations : []
        }
      },
      created() {
        var lon = storeJs.get('prtv:lon')
        var lat = storeJs.get('prtv:lat')
        var rayon = this.$store.state.rayonLte
        axios.get('/emetteurlte' + '?lon=' + lon + '&lat=' + lat + '&rayon=' + rayon).then((response)=>{
          this.stations = response.data.features
        }).catch((error)=>{
          console.error(error)
        })
      },
      mounted(){
        document.body.classList.add('hamburger_menu');
        this.$store.state.menu.active = false;
      },
      destroyed() {
        document.body.classList.remove('hamburger_menu');
      },
      methods: {
        findClass(dateDebut){
          if (dateDebut && dateDebut != null && dateDebut != "") {
            var date = new Date(dateDebut)
            var weekago = new Date()
            weekago.setDate(weekago.getDate() - 7)
            if (date > weekago) {
              return '#F3BB00'
            } else {
              return '#05D8D5'
            }
          }
            return '#515151'
        },
        findTitle(dateDebut){
          if (dateDebut && dateDebut != null && dateDebut != "") {
            var date = new Date(dateDebut)
            var weekago = new Date()
            weekago.setDate(weekago.getDate() - 7)
            if (date > weekago) {
              return "Mise en service il y a moins d'une semaine"
            } else {

              return "Mise en service il y a une semaine ou plus"
            }
          }
            return "Cette station n'a pas de date de mise en service"
        },
        openLte(station){
          if(station){
            this.$refs['ficheStation'].loadLte(station)
          }
        },
        printDate(value) {
          return (value != null) ? moment(new Date(value)).format('DD/MM/YYYY') : null;
        },
        parseDistance(distance) {
          var distance = parseFloat(distance.toString())
          return Math.round(distance * 100) / 100;
        }
      }
    }
    </script>
<style>
.pin.pin_station_4G {
  background-color: #05D8D5;
  border-radius: 50px;
}

.pin.pin_station_4G.station_4G_out {
  background-color: #515151;
}

.pin.pin_station_4G.station_4G_recent {
  background-color: #F3BB00;
}
    </style>
